import { userGroups } from 'root/src/shared/constants/auth'
import {
	AGENCY_PUBLISHERS_LIST_ROUTE_ID,
	CAMPAIGNS_PAGE_ROUTE_ID,
	LOGIN_ROUTE_ID,
	PENDING_DELIVERIES_ROUTE_ID,
	VIEWERS_PAGE_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'

export const groupDefaultRouteIdMap = {
	[userGroups.user]: LOGIN_ROUTE_ID,
	// Publisher side lands on the campaigns list, which is the brand workspace home.
	// Account settings is a destination you go to on purpose, not somewhere to be
	// dropped after verifying an account.
	[userGroups.brand]: CAMPAIGNS_PAGE_ROUTE_ID,
	[userGroups.viewer]: VIEWERS_PAGE_ROUTE_ID,
	[userGroups.creator]: routeUrls.drops(),
	[userGroups.admin]: PENDING_DELIVERIES_ROUTE_ID,
	[userGroups.agency]: AGENCY_PUBLISHERS_LIST_ROUTE_ID,
	[userGroups.agencyAccountManager]: AGENCY_PUBLISHERS_LIST_ROUTE_ID,
	[userGroups.brandAdmin]: CAMPAIGNS_PAGE_ROUTE_ID,
	[userGroups.brandUser]: CAMPAIGNS_PAGE_ROUTE_ID,
}
